import * as React from 'react'
import { Text, TouchableOpacity, View, Linking } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import Select from '@components/select/Select'
import TextInput from '@components/textInput/TextInputButton'
import SimpleAlert from '@components/modal/SimpleAlert'

import LoginForm from '@screens/login/LoginForm'

import { getSsoUrl } from '@utils/login'

import useI18n from '@i18n/useI18n'
import useBreakpoints from '@utils/useBreakpoints'
import * as AuthStore from '@store/auth/auth'
import * as store from '@store/store'

import api from '@api/api'
import Logger from '@utils/logger'

interface Props {
  onLoginSuccess?: () => void
  onBack: () => void
  onPressForgetPassword: () => void
  // TODO : corriger la navigation impossible depuis le drawer
  navigation: Navigation
}

const ExhibitorView = ({ onLoginSuccess, onBack, onPressForgetPassword, navigation }: Props) => {
  const i18n = useI18n()
  // const navigation = useNavigation()

  const [, bp] = useBreakpoints()
  const [incidentNumber, setIncidentNumber] = React.useState('')
  const [loginMode, setLoginMode] = React.useState(false)

  const authentGuest = () =>
    api.authentification.guest().then((res) =>
      AuthStore.actions.setTokens({
        access: res.access_token,
        expireIn: res.expires_in,
        scopes: res.scopes,
        refresh: res.refresh_token,
      })
    )

  const onIncidentNumberSubmit = () => {
    if (incidentNumber !== undefined) {
      authentGuest()
      navigation.push(`/incidentDetailExpo/${incidentNumber}`, { incidentNumber })
      onBack()
    }
  }

  const onStartIncident = () => {
    store.reset()
    authentGuest()
      .then(() => navigation.push(`/incident/site_expo`))
      .then(onBack)
  }

  const onSso = () => {
    api.authentification
      .ssoInfo()
      .then((res) => {
        const redirectUrl = getSsoUrl(res)
        if (window) {
          window.open(redirectUrl, '_self')
        } else {
          Linking.openURL(redirectUrl)
        }
      })
      .catch((err) => {
        Logger.error(err)
        SimpleAlert.open({
          title: i18n.t('common.errorTitle'),
          description: i18n.t('common.error'),
          buttons: [{ label: i18n.t('common.ok'), onClick: () => SimpleAlert.close() }],
        })
      })
  }

  if (loginMode) {
    return (
      <LoginForm
        onBack={() => setLoginMode(false)}
        onLoginSuccess={onLoginSuccess}
        onPressForgetPassword={onPressForgetPassword}
      />
    )
  }

  return (
    <MainContainer>
      {bp !== 'phone' && (
        <BackButton onPress={onBack}>
          <Icon name="long-arrow-left" size={40} color="black" />
        </BackButton>
      )}
      <Title>{i18n.t('screens.login.exhibitor.title')}</Title>
      <SelectContainer>
        <Select label={i18n.t('screens.login.exhibitor.startIncident')} onClick={onStartIncident} selectStyle="bold" />
      </SelectContainer>
      <SelectContainer>
        <FollowContainer>
          <FollowTitle>{i18n.t('screens.login.exhibitor.followIncident')}</FollowTitle>
          <TextInput
            value={incidentNumber}
            placeholder={i18n.t('screens.login.exhibitor.incidentNumber')}
            onChange={setIncidentNumber}
            onSubmit={onIncidentNumberSubmit}
          />
        </FollowContainer>
      </SelectContainer>

      <SelectContainer>
        <Select label={i18n.t('screens.login.exhibitor.viparisStore')} onClick={onSso} selectStyle="bold" />
      </SelectContainer>
      <SelectContainer>
        <Select label={i18n.t('screens.login.exhibitor.scanQRCode')} onClick={() => undefined} selectStyle="bold" />
      </SelectContainer>
    </MainContainer>
  )
}

export default ExhibitorView

const MainContainer = styled(View)`
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? '0px 16px 220px 16px' : '0px 48px')};
  ${(props) => (props.theme.breakpoint === 'phone' ? 'margin-bottom: 48px;' : 'flex: 1; justify-content: center;')}
`
const BackButton = styled(TouchableOpacity)`
  margin-bottom: 30px;
`
const Title = styled(Text)`
  ${(props) => props.theme.fonts.Title2};
  color: ${(props) => props.theme.colors.secondaryText};
  font-size: 28px;
  margin-bottom: 40px;
  line-height: 32px;
  max-width: 430px;
`
const SelectContainer = styled(View)<{ isLast?: boolean }>`
  ${(props) => !props.isLast && `margin-bottom: 24px;`}
`
const FollowContainer = styled(View)`
  padding: 24px 20px;
  background-color: ${(props) => props.theme.colors.secondaryActive};
`
const FollowTitle = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-bottom: 8px;
`
